(function () {
  'use strict';

  /* ═══════════════════════════════════════════════════════════════════
     Country / currency selector — native Shopify localization.
     Selecting a country submits Shopify's localization form, which
     reloads the page in that country's context: every price (pages,
     cart, checkout) is then rendered by Shopify in the local currency
     at real exchange rates. No client-side price rewriting.
     Countries listed = countries enabled in Admin → Settings → Markets.
     ═══════════════════════════════════════════════════════════════════ */

  /* ── Region grouping — order controls display order in the picker ── */
  var REGION_ORDER = ['Americas', 'Europe', 'Asia', 'Oceania', 'Middle East', 'Other Countries / Regions'];
  var COUNTRY_REGION = {
    US: 'Americas', CA: 'Americas', BR: 'Americas', MX: 'Americas', AR: 'Americas', CL: 'Americas', CO: 'Americas',
    GB: 'Europe', DE: 'Europe', FR: 'Europe', IT: 'Europe', ES: 'Europe', NL: 'Europe', BE: 'Europe',
    AT: 'Europe', PT: 'Europe', IE: 'Europe', FI: 'Europe', GR: 'Europe', LU: 'Europe',
    SK: 'Europe', SI: 'Europe', EE: 'Europe', LV: 'Europe', LT: 'Europe', MT: 'Europe', CY: 'Europe',
    SE: 'Europe', DK: 'Europe', NO: 'Europe', CH: 'Europe', PL: 'Europe', CZ: 'Europe', HU: 'Europe', RO: 'Europe', BG: 'Europe', HR: 'Europe', IS: 'Europe',
    JP: 'Asia', CN: 'Asia', HK: 'Asia', TW: 'Asia', KR: 'Asia', IN: 'Asia',
    SG: 'Asia', MY: 'Asia', TH: 'Asia', VN: 'Asia', ID: 'Asia', PH: 'Asia',
    AU: 'Oceania', NZ: 'Oceania',
    AE: 'Middle East', SA: 'Middle East', QA: 'Middle East', KW: 'Middle East', BH: 'Middle East', OM: 'Middle East', IL: 'Middle East', TR: 'Middle East',
  };

  /* ── 2-letter ISO country code → flag emoji ── */
  function countryCodeToFlag(code) {
    if (!code || code.length !== 2) return '\uD83C\uDF10';
    var points = [];
    for (var i = 0; i < 2; i++) points.push(0x1F1E6 + code.toUpperCase().charCodeAt(i) - 65);
    return String.fromCodePoint.apply(String, points);
  }

  /* ── Countries available in this store (rendered by Liquid from Markets) ── */
  function getCountries() {
    var el = document.querySelector('[data-ship-to-countries]');
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
  }

  function regionOf(iso) {
    return COUNTRY_REGION[iso] || 'Other Countries / Regions';
  }

  /* ── Submit Shopify's localization form with the chosen country ── */
  function selectCountry(iso) {
    var form = document.getElementById('footer-localization-form');
    var input = document.querySelector('[data-ship-to-input]');
    if (!form || !input) return;
    try {
      localStorage.setItem('jaffary_locale_set', '1');
      localStorage.setItem('jaffary_locale_iso', iso);
    } catch (e) {}
    input.value = iso;
    form.submit(); /* page reloads in new country context: prices, cart & checkout follow */
  }

  /* ── First visit: auto-detect country by IP and localize once.
       Never runs again after any choice (auto or manual), never fights
       the user, and only switches to countries the store ships to. ── */
  /* ── Self-healing: if this page rendered in a different country than the
       user's saved choice (session loss, cache edge), silently re-apply it. ── */
  function enforceSavedCountry() {
    var saved = null;
    try { saved = localStorage.getItem('jaffary_locale_iso'); } catch (e) {}
    if (!saved) return false;
    var input = document.querySelector('[data-ship-to-input]');
    if (!input || input.value === saved) return false;
    var guard = null;
    try { guard = sessionStorage.getItem('jaffary_locale_reapply'); } catch (e) {}
    if (guard === saved + ':' + location.pathname) return false; /* avoid loops if Markets rejects it */
    try { sessionStorage.setItem('jaffary_locale_reapply', saved + ':' + location.pathname); } catch (e) {}
    var available = getCountries().some(function (c) { return c.iso === saved; });
    if (!available) return false;
    selectCountry(saved);
    return true;
  }

  function autoDetectCountry() {
    if (enforceSavedCountry()) return;
    var already = null;
    try { already = localStorage.getItem('jaffary_locale_set'); } catch (e) {}
    if (already) return;
    var input = document.querySelector('[data-ship-to-input]');
    if (!input) return;
    fetch('https://ipwho.is/')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var detected = (data && data.country_code || '').toUpperCase();
        try { localStorage.setItem('jaffary_locale_set', '1'); } catch (e) {}
        if (!detected) return;
        var available = getCountries().some(function (c) { return c.iso === detected; });
        /* Country not in our Markets? Show USD (United States context) instead of the EUR default. */
        var target = available ? detected : 'US';
        var targetAvailable = available || getCountries().some(function (c) { return c.iso === 'US'; });
        try { localStorage.setItem('jaffary_locale_iso', targetAvailable ? target : input.value); } catch (e) {}
        if (!targetAvailable || target === input.value) return;
        selectCountry(target);
      })
      .catch(function () { /* detection failed: stay on store default */ });
  }

  /* ── Picker UI (two levels: regions → countries), same design as before ── */
  function renderRegionList(body) {
    body.innerHTML = '';
    var countries = getCountries();
    REGION_ORDER.forEach(function (region) {
      var inRegion = countries.filter(function (c) { return regionOf(c.iso) === region; });
      if (inRegion.length === 0) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'footer__ship-to-region';
      btn.setAttribute('data-testid', 'region-' + region.replace(/\s+/g, '-').toLowerCase());
      btn.innerHTML =
        '<span class="footer__ship-to-region-name">' + region + '</span>' +
        '<span class="footer__ship-to-region-count">' + inRegion.length + '</span>';
      btn.addEventListener('click', function () { renderCountryList(body, region); });
      body.appendChild(btn);
    });
    if (countries.length <= 1) {
      var note = document.createElement('p');
      note.className = 'footer__ship-to-heading';
      note.textContent = 'More countries coming soon.';
      body.appendChild(note);
    }
  }

  function renderCountryList(body, region) {
    body.innerHTML = '';
    var backBtn = document.createElement('button');
    backBtn.type = 'button';
    backBtn.className = 'footer__ship-to-back';
    backBtn.textContent = '\u2190 ' + region;
    backBtn.addEventListener('click', function () { renderRegionList(body); });
    body.appendChild(backBtn);

    var activeIso = (document.querySelector('[data-ship-to-input]') || {}).value || '';
    getCountries()
      .filter(function (c) { return regionOf(c.iso) === region; })
      .sort(function (a, b) { return a.name.localeCompare(b.name); })
      .forEach(function (c) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'footer__ship-to-option' + (c.iso === activeIso ? ' is-active' : '');
        btn.setAttribute('data-testid', 'option-ship-to-' + c.iso);
        btn.innerHTML =
          '<span class="footer__ship-to-option-flag" aria-hidden="true">' + countryCodeToFlag(c.iso) + '</span>' +
          '<span class="footer__ship-to-option-name">' + c.name + ' (' + c.currency + ' ' + c.symbol + ')</span>';
        btn.addEventListener('click', function () { selectCountry(c.iso); });
        body.appendChild(btn);
      });
  }

  function closeShipToDropdown() {
    var dropdown = document.querySelector('[data-ship-to-dropdown]');
    var overlay = document.querySelector('[data-ship-to-overlay]');
    if (dropdown) dropdown.hidden = true;
    if (overlay) overlay.hidden = true;
  }

  function setupShipToUI() {
    var toggle = document.querySelector('[data-ship-to-toggle]');
    var dropdown = document.querySelector('[data-ship-to-dropdown]');
    var overlay = document.querySelector('[data-ship-to-overlay]');
    if (!toggle || !dropdown || !overlay) return;

    /* Flag on the button reflects the server-rendered current country */
    var flagEl = document.querySelector('[data-ship-to-flag]');
    if (flagEl) flagEl.textContent = countryCodeToFlag(flagEl.getAttribute('data-country-iso'));

    toggle.addEventListener('click', function () {
      var willOpen = dropdown.hidden;
      if (willOpen) renderRegionList(dropdown.querySelector('[data-ship-to-body]'));
      dropdown.hidden = !willOpen;
      overlay.hidden = !willOpen;
    });
    overlay.addEventListener('click', closeShipToDropdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setupShipToUI(); autoDetectCountry(); });
  } else {
    setupShipToUI();
    autoDetectCountry();
  }

  /* ── Back-compat shim: old code referenced window.JaffaryCurrency.
       Prices are now always in Shopify's active currency, so conversion
       is identity and formatting mirrors what Liquid already rendered. ── */
  window.JaffaryCurrency = {
    getConfig: function () {
      var c = (window.Shopify && window.Shopify.currency) || {};
      return { code: c.active || 'EUR', rate: 1, symbol: '', pos: 'before' };
    },
    convertFromStoreCurrency: function (amount) { return amount; },
    formatFromStoreCurrency: function (amount) { return amount.toLocaleString(); },
    onReady: function (fn) { fn(this.getConfig()); }
  };
})();
